/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export type API56386Item = {};
    
  



export interface API56386Req {
  
  /** (String) */
  bizNo?: string;
    
  /** (Integer) */
  bizType?: string;
    
};



export interface API56386Res {
  /** 业务编号  */
  bizNo?: string;
  /** 业务类型：1.项目2.业务  */
  bizType?: number;
  /** 数据目标  */
  dataTarget?: number;
  /** 数据达成  */
  dataReach?: number;
  /** 业务指标：1.gmv指标  */
  businessIndicator?: number;
  /** 业务指标展示字段  */
  businessIndicatorStr?: string;
  /** 业务指标类型：1.gmv退款后  */
  businessIndicatorType?: number;
  /** 业务指标类型展示字段  */
  businessIndicatorTypeStr?: string;
  /** 指标对象 ,List  */
  indicatorObject?: API56386Item[];
  /** 指标对象展示字段  */
  indicatorObjectStr?: string;
  /** 指标开始时间  */
  indicatorDateStart?: any;
  /** 指标结束时间  */
  indicatorDateEnd?: any;
  /** 是否取消  */
  isCancel?: boolean;
  
};


// 56386 查询指标

export interface IUseGetAPI56386Return {
  /** 查询指标: 接口请求状态 */
  isAPI56386Loading: boolean;
  /** 查询指标: 接口请求返回数据 */
  dataAPI56386: API56386Res;
  /**  查询指标: 接口数据请求方法 */
  fetchAPI56386Data:  (inputs: API56386Req, config?: YWRequestConfig) => Promise<API56386Res>;
  /** 查询指标: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI56386 = ():IUseGetAPI56386Return => {
  let isMount = true;
  const [isAPI56386Loading, setIsAPI56386Loading] = useState(false);
  const [dataAPI56386, setDataAPI56386] = useState<API56386Res>({} as API56386Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/indicator/get`;

  const fetchAPI56386Data = async (inputs: API56386Req, config?: YWRequestConfig): Promise<API56386Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API56386Req>) || {}) as API56386Req;
    
  
    if ( isMount ) {
      setIsAPI56386Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API56386Res>(`${basePath}/corp-admin/project/plan/task/indicator/get?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI56386(res || {} as API56386Res);
        setIsAPI56386Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI56386Loading(false);
      }
      return false as unknown as API56386Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI56386Loading,
    dataAPI56386,
    fetchAPI56386Data,
    requestUrl,
  }
}

